<template>
    <recipe-listings-section
        class="recipe-listings-section-module"
        :recipes="recipes"
        :categories="attributes.asyncData.formattedRecipeCategories"
        :selected-categories.sync="selectedCategories"
    />
</template>

<script>
    import RecipeListingsSection from '../../../organisms/RecipeListingsSection/RecipeListingsSection';
    import { formatRecipeCategories, formatRecipeListings } from '../../../../lib/recipes';

    export default {
        name: 'recipe-listings-section-module',

        components: { RecipeListingsSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        async asyncData({ store, route, query, includeCategories = true }) {
            let selectedCategories = query.category || [];

            selectedCategories = Array.isArray(selectedCategories) ? selectedCategories : [selectedCategories];

            const locale = store.state.locales.locales.find(({ code }) => code === route.path.split('/')[1] ?? 'en')?.code ?? 'en';

            // On page load we want to fetch both recipes and recipe categories so we set includeCategories to true
            const { recipes, recipeCategories } = await store.dispatch('recipes/fetchRecipes', {
                includeCategories,
                categories: selectedCategories,
                locale,
            });

            const formattedRecipeCategories = formatRecipeCategories(recipeCategories);

            return {
                recipes,
                formattedRecipeCategories,
                selectedCategories,
            };
        },

        data() {
            return {
                selectedCategories: this.attributes.asyncData.selectedCategories ?? [],
                recipes: [
                    ...formatRecipeListings(this, this.attributes.asyncData.recipes),
                ],
            };
        },

        watch: {
            /**
             * Re-fetch recipes on selected category change.
             */
            async selectedCategories() {
                await this.fetchRecipes();
            },
        },

        methods: {
            /**
             * Fetch Recipes.
             *
             * We call the async data method again but this time not fetching the categories, only the updated recipes.
             */
            async fetchRecipes() {
                // $options allows us to access anything on the component not the instance
                const { recipes } = await this.$options.asyncData({
                    store: this.$store,
                    route: this.$route,
                    includeCategories: false,
                    query: {
                        category: this.selectedCategories,
                    },
                });

                // Persist the selected category in the route.
                if (JSON.stringify(this.selectedCategories) !== JSON.stringify(this.$route.query.category)) {
                    this.$router.push({
                        query: {
                            category: this.selectedCategories || undefined,
                        },
                    });
                }

                this.recipes = formatRecipeListings(this, recipes);
            },
        },
    };
</script>
